
    <!-- <a routerLink="/pages" class="layout-topbar-logo">
        <span style="color: #000;line-height: 44px;font-size: 20px;">BackOffice</span>
    </a> -->
    <a (click)="app.onMenuClick($event);app.menuActive = !app.menuActive;" id="menu-button" class="layout-menu-button">
        <i class="pi pi-bars"></i>
    </a>
    <a (click)="userDisplay = !userDisplay" id="topbar-menu-button"><i class="pi pi-ellipsis-v"></i></a>

    <!-- <div class="notification-icon" (click)="toggleDropdown()">
        <i class="fas fa-bell"></i>
        <span class="notification-count">{{withdrawRequest}}</span>
        <div class="ui-g-12 ui-md-8 dropdown-container" *ngIf="showDropdown">
            <p-dropdown [options]="totalUsers" placeholder="{{ 'Seçiniz' | translate }}" filter="true"
                 name="domainId"></p-dropdown>
        </div>
      </div>  -->




    <ul class="topbar-menu fadeInDown animated" id="topbar-menu" [ngClass]="{'topbar-menu-visible':userDisplay}">
        <li class="user-profile" style="display: flex;align-items: center;margin: 0;" [ngClass]="{'active-topmenuitem':userDisplay}">

            <div class="user-info">
                <!-- <span class="username">{{app.user.username}}</span> -->
                <span class="limit" *ngIf="app.user.userType === 0 || app.user.userType === -1"><i class="fa fa-credit-card"></i> {{app.user.limit | currency:'':''}}</span>
            </div>
            <a (click)="userDisplay = !userDisplay" id="user-display" style="cursor: pointer;">
                <img alt="babylon-layout" src="assets/images/avatar.png">
            </a>
            <ul class="fadeInDown" style="z-index: 1;">
                <div class="flexBox">
                <h3 class="mg-3" style="margin:2px;">{{this.getUserName}}</h3>
                <div class="user-info-Mobile">
                    <!-- <span class="username">{{app.user.username}}</span> -->
                    <span class="limit" *ngIf="app.user.userType === 0 || app.user.userType === -1"><i class="fa fa-credit-card"></i> {{app.user.limit | currency:'':''}}</span>
                </div>
            </div>
                <li role="menuitem">
                    <p-dropdown [options]="languages" [style]="{width: '100%'}"
                                [ngModel]="translate.currentLang" appendTo="body"
                                (onChange)="changeLanguage($event.value)">
                        <ng-template pTemplate="selectedItem" let-item>
                            {{item.label | translate}}
                        </ng-template>
                        <ng-template let-option pTemplate="item">
                            <span>{{option.label | translate}}</span>
                        </ng-template>
                    </p-dropdown>

                </li>

                <li role="menuitem">
                        <a class="flex" (click)="app.logout()" style="cursor: pointer;">
                        <i class="fas fa-fw fa-sign-out-alt"></i>
                        <span>Logout</span>
                    </a>
                </li>
            </ul>
        </li>
    </ul>


<!-- telegram icon -->
<div class="chats-icon" *ngIf="app.user.userType === 1 || app.user.userType === 0" (click)="openTelegramModal()">
    <div  style="color:#fff; margin-right: 10px; margin-top: 3px;">
        <i class="fas fa-paper-plane" style="font-size: 1rem;"></i>
    </div>
</div>
<!-- telegram icon -->

 <!-- chat code -->
<div class="chats-icon">
    <a routerLink="/pages/conversation" class="layout-topbar-logo">
 <div class="mr-25" (click)="toggleCommentsDropdown()" *ngIf="this.app.user.userType !== -1">
    <i class="fas fa-comments"></i>
    <span class="comments-count" *ngIf="newMessageCount">{{ newMessageCount }}</span>
    </div></a>
</div>
<!-- chat code -->

        <!-- notifications -->
        <div class="notification-icon mr-25" *ngIf="app.user.userType === 1 || app.user.userType === 0">
            <div style="position:relative;cursor:pointer;" (click)="toggleNotificationDropdown(); $event.stopPropagation()">
                <i class="fas fa-bell"></i>
                <span *ngIf="unreadCount" class="notification-count">{{ unreadCount }}</span>
            </div>
            <ng-container *ngIf="showNotificationDropdown">
                <div class="ui-g-12 ui-md-12 dropdown-container">
                    <div style="display:flex;align-items:center;justify-content:space-between;padding:0.5rem 0.75rem;border-bottom:1px solid #e0e0e0;">
                        <h3 class="notifi" style="border:none;padding:0;margin:0;">{{ 'Bildirimler' | translate }}</h3>
                        <a *ngIf="unreadCount" (click)="markAllRead()"
                           style="font-size:11px;cursor:pointer;color:#6967eb;white-space:nowrap;">
                            {{ 'Tümünü Okundu İşaretle' | translate }}
                        </a>
                    </div>
                    <ul class="overflow">
                        <li *ngIf="notifications.length === 0" style="padding:1rem;text-align:center;color:#999;">
                            {{ 'Bildirim yok' | translate }}
                        </li>
                        <li *ngFor="let n of notifications"
                            (click)="markRead(n)"
                            [style.background]="!+n.isRead ? '#f0f4ff' : ''"
                            style="cursor:pointer;">
                            <div style="display:flex;flex-direction:column;gap:2px;">
                                <span [style.font-weight]="!+n.isRead ? '600' : '400'"
                                      [innerHTML]="interpolateMessage(n.message, n.data)">
                                </span>
                                <small style="color:#999;font-size:11px;">{{ dateTimeService.formatDate(n.createdAt) }}</small>
                            </div>
                        </li>
                    </ul>
                </div>
            </ng-container>
        </div>
        <!-- notifications -->

<!-- telegram modal -->
<p-dialog header="{{ 'Telegram Bağlantısı' | translate }}"
          [(visible)]="telegramModalVisible"
          [modal]="true"
          [style]="{width: '400px'}"
          appendTo="body"
          [blockScroll]="true"
          (onHide)="onTelegramModalHide()">

    <div *ngIf="telegramStatusLoading" style="text-align:center;padding:20px;">
        <i class="fas fa-spinner fa-spin" style="font-size:1.5rem;"></i>
    </div>

    <ng-container *ngIf="!telegramStatusLoading">
        <div style="margin-bottom:16px;display:flex;align-items:center;gap:10px;">
            <span>{{ 'Durum' | translate }}:</span>
            <span *ngIf="telegramLinked"
                  style="display:inline-flex;align-items:center;gap:6px;padding:3px 10px;border-radius:12px;background:#d4edda;color:#155724;font-weight:600;">
                <i class="fas fa-check-circle"></i>{{ 'Bağlı' | translate }}
            </span>
            <span *ngIf="!telegramLinked"
                  style="display:inline-flex;align-items:center;gap:6px;padding:3px 10px;border-radius:12px;background:#e2e3e5;color:#383d41;font-weight:600;">
                <i class="fas fa-times-circle"></i>{{ 'Bağlı Değil' | translate }}
            </span>
        </div>

        <ng-container *ngIf="!telegramLinked">
            <button pButton type="button"
                    icon="fas fa-paper-plane"
                    label="{{ (telegramLinkLoading ? 'Yükleniyor...' : 'Bağlantı Linki Al') | translate }}"
                    [disabled]="telegramLinkLoading"
                    (click)="linkTelegram()">
            </button>
            <div *ngIf="telegramLink" style="margin-top:14px;">
                <a [href]="telegramLink" target="_blank"
                   style="display:block;word-break:break-all;font-size:12px;color:#0088cc;margin-bottom:8px;line-height:1.4;">
                    {{ telegramLink }}
                </a>
                <button type="button" (click)="copyTelegramLink()"
                        style="font-size:12px;padding:4px 10px;cursor:pointer;border:1px solid #ccc;border-radius:4px;background:#f5f5f5;">
                    <i [class]="telegramLinkCopied ? 'fas fa-check' : 'fas fa-copy'" style="margin-right:4px;"></i>
                    {{ (telegramLinkCopied ? 'Kopyalandı' : 'Kopyala') | translate }}
                </button>
            </div>
        </ng-container>

        <ng-container *ngIf="telegramLinked">
            <button pButton type="button"
                    class="ui-button-danger"
                    icon="fas fa-paper-plane"
                    label="{{ (telegramDisconnectLoading ? 'Yükleniyor...' : 'Bağlantıyı Kes') | translate }}"
                    [disabled]="telegramDisconnectLoading"
                    (click)="disconnectTelegram()">
            </button>
        </ng-container>
    </ng-container>
</p-dialog>
<!-- telegram modal -->

